
import { useState } from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { LinkShare } from './LinkShare';
import { MessageShare } from './MessageShare';
import { QRCodeShare } from './QRCodeShare';

interface SharingToolsCardProps {
  referralUrl: string | null;
}

export function SharingToolsCard({ referralUrl }: SharingToolsCardProps) {
  const [activeTab, setActiveTab] = useState('link');


  
  return (
    <Card>
      <CardHeader>
        <CardTitle>Sharing Tools</CardTitle>
        <CardDescription>Different ways to share your referral link</CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="link">Link</TabsTrigger>
            <TabsTrigger value="message">Message</TabsTrigger>
            <TabsTrigger value="qrcode">QR Code</TabsTrigger>
          </TabsList>
          
          <TabsContent value="link" className="pt-4">
            <LinkShare referralUrl={referralUrl} />
          </TabsContent>
          
          <TabsContent value="message" className="pt-4">
            <MessageShare referralUrl={referralUrl} />
          </TabsContent>
          
          <TabsContent value="qrcode" className="pt-4">
            <QRCodeShare referralUrl={referralUrl} />
          </TabsContent>
        </Tabs>
      </CardContent>
      <CardFooter className="flex flex-col">
        <p className="text-sm text-muted-foreground">
          When friends sign up using your link, they'll get 30% off their first 3 months, 
          and you'll earn rewards after 3 successful referrals.
        </p>
      </CardFooter>
    </Card>
  );
}
